import { render, staticRenderFns } from "./RegionForm.vue?vue&type=template&id=7ed5bd19&scoped=true&"
import script from "./RegionForm.vue?vue&type=script&lang=js&"
export * from "./RegionForm.vue?vue&type=script&lang=js&"
import style0 from "./RegionForm.vue?vue&type=style&index=0&id=7ed5bd19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed5bd19",
  null
  
)

export default component.exports